import { useSelector, useDispatch } from 'react-redux';
import {
	addBetBuilderBetToBetslip,
	closeBetBuilder,
	selectIsOpen,
	selectBetBuilderUrl,
	selectIsGeneratingBetBuilderUrl,
	selectIsAddingToBetslip
} from './sportsbook-bet-builder-modal-duck';
import BetBuilderModal from './sportsbook-bet-builder-modal';
import { AppDispatch } from '../../../../../store/types';
import { useTypedTranslations } from '../../../../translation/use-translations';
import BetBuilderTextKeys from './sportsbook-bet-builder-modal-text-keys';

const BetBuilderContainer = () => {
	const dispatch: AppDispatch = useDispatch();
	const isOpen = useSelector(selectIsOpen);
	const betBuilderUrl = useSelector(selectBetBuilderUrl);
	const handleClose = () => dispatch(closeBetBuilder());
	const handleAddToBetslip = (betBuilderBetId: string) => dispatch(addBetBuilderBetToBetslip(betBuilderBetId));
	const { translations } = useTypedTranslations(BetBuilderTextKeys);

	const isGeneratingBetBuilderUrl = useSelector(selectIsGeneratingBetBuilderUrl);
	const isAddingToBetslip = useSelector(selectIsAddingToBetslip);

	if (!isOpen) {
		return null;
	}

	return (
		<BetBuilderModal
			translations={translations}
			iframeUrl={betBuilderUrl}
			onClose={handleClose}
			onAddToBetslip={handleAddToBetslip}
			isLoading={isGeneratingBetBuilderUrl || isAddingToBetslip}
		/>
	);
};
export default BetBuilderContainer;
